import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import appConfig from 'src/config/appConfig';

/**
 * Custom hook to determine if the current screen is a mobile device.
 * Uses Material UI's default mobile breakpoint (down from "sm").
 *
 * @returns {boolean} True if the device is mobile-sized.
 */
const useIsMobile = (): boolean => {
  const theme = useTheme();
  const isMobile = useMediaQuery(
    theme.breakpoints.down(appConfig.breakMobileView)
  );
  return isMobile;
};

export default useIsMobile;
